import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { formatPrice, mapProductTypeToProductCategory, mapProductStockToProductStatus } from "@grandvisionhq/svc-tealium/utils";
import { isDefined } from "@grandvisionhq/utils";
import { getActiveVariant, getProductModelName, getAvailableQuantity } from "../../../../../../helpers.js";
const mapProductToTealiumImpressionProperties = (configFlow, product, activeSku, productType, productPrice, lensUpc, locale) => {
  if (!product || !activeSku || !productType || !locale || !configFlow) {
    return void 0;
  }
  const activeVariant = getActiveVariant(product, activeSku);
  let originalPrice = "";
  let discountedPrice = "";
  if (productPrice) {
    originalPrice = formatPrice(productPrice.originalPrice, true);
    discountedPrice = productPrice.discountedPrice ? formatPrice(productPrice.discountedPrice, true) : originalPrice;
  }
  const productProperties = {
    Category: mapProductTypeToProductCategory(productType),
    ModelName: getProductModelName(activeVariant, locale, productType),
    Price: discountedPrice,
    PriceFull: originalPrice,
    LensType: "RX",
    Units: "1",
    LensUPC: lensUpc || "",
    Brand: activeVariant.brand || ""
  };
  const isPublished = Boolean(product.published && activeVariant.isPublished);
  if (!CommerceToolsApi.isLenses(productType) && isDefined(activeVariant.availability)) {
    const availableQuantity = getAvailableQuantity(activeVariant.availability);
    productProperties.Status = mapProductStockToProductStatus(availableQuantity, isPublished);
  }
  const payload = {
    id: "Impression",
    Page_Section1: CommerceToolsApi.isSunglasses(productType) ? "SunLensPanel" : "LensPanel",
    Page_Section2: configFlow.stepName ?? "",
    Rx_Release: configFlow.version,
    Products: {
      [activeSku]: productProperties
    }
  };
  return payload;
};
export {
  mapProductToTealiumImpressionProperties
};
//# sourceMappingURL=map-product-to-tealium-impression-properties.js.map
